import { render } from "./AppVersionManagementEdit.vue?vue&type=template&id=becc720e&scoped=true"
import script from "./AppVersionManagementEdit.vue?vue&type=script&lang=js"
export * from "./AppVersionManagementEdit.vue?vue&type=script&lang=js"

import "./AppVersionManagementEdit.vue?vue&type=style&index=0&id=becc720e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-becc720e"]])

export default __exports__